const PROTECTED_SPLIT = /(BeepApp|Telegram|AutoClan|Pit Stop|PROMO CODE|Affiliate|Stars|@username|\{[^}]+\})/g
const PROTECTED_TOKEN = /^(BeepApp|Telegram|AutoClan|Pit Stop|PROMO CODE|Affiliate|Stars|@username|\{[^}]+\})$/

function preserveCase(source: string, replacement: string): string {
  if (source === source.toUpperCase()) return replacement.toUpperCase()
  if (source[0] === source[0]?.toUpperCase()) {
    return replacement[0]?.toUpperCase() + replacement.slice(1)
  }
  return replacement
}

function transliterateSegment(input: string): string {
  let out = ""
  let index = 0

  while (index < input.length) {
    const rest = input.slice(index)
    const lower = rest.toLocaleLowerCase("uz-Latn")
    const pairs: readonly [string, string][] = [
      ["yoʻ", "йў"], ["yo‘", "йў"], ["yo'", "йў"],
      ["oʻ", "ў"], ["o‘", "ў"], ["o'", "ў"],
      ["gʻ", "ғ"], ["g‘", "ғ"], ["g'", "ғ"],
      ["sh", "ш"], ["ch", "ч"], ["yo", "ё"], ["yu", "ю"], ["ya", "я"], ["ye", "е"], ["ts", "ц"],
    ]

    let matched = false
    for (const [latin, cyrillic] of pairs) {
      if (lower.startsWith(latin)) {
        const source = rest.slice(0, latin.length)
        out += preserveCase(source, cyrillic)
        index += latin.length
        matched = true
        break
      }
    }
    if (matched) continue

    const char = input[index]
    const lowerChar = char.toLocaleLowerCase("uz-Latn")
    const atWordStart = index === 0 || !/[A-Za-zʻ’']/u.test(input[index - 1])
    const map: Record<string, string> = {
      a:"а", b:"б", d:"д", e: atWordStart ? "э" : "е", f:"ф", g:"г", h:"ҳ",
      i:"и", j:"ж", k:"к", l:"л", m:"м", n:"н", o:"о", p:"п", q:"қ", r:"р",
      s:"с", t:"т", u:"у", v:"в", x:"х", y:"й", z:"з",
    }
    const mapped = map[lowerChar]
    out += mapped ? preserveCase(char, mapped) : char
    index += 1
  }

  return out
}

/**
 * BeepApp exposes one Uzbek locale code (`uz`) and renders it only in Uzbek
 * Cyrillic. The historical Latin catalogs remain internal source material;
 * this adapter is applied at every public runtime resolver.
 */
export function uzbekLatinToCyrillic(value: string): string {
  return value
    .split(PROTECTED_SPLIT)
    .map((part) => PROTECTED_TOKEN.test(part) ? part : transliterateSegment(part))
    .join("")
}
